<template>
  <v-collapse-group>
    <v-collapse-wrapper :active="true">
      <div class="a-tab__title-block admin__a-tab admin__a-tab--modification-controls"
           v-collapse-toggle>
        <h3>{{$t('form.lot.expert-criteria')}}</h3>
      </div>
      <div class="admin__a-tab-content admin__a-tab-content--show" v-collapse-content>
        <expert-criteria :lot="lot"></expert-criteria>
      </div>
    </v-collapse-wrapper>

    <v-collapse-wrapper :active="true">
      <div class="a-tab__title-block admin__a-tab admin__a-tab--modification-controls"
           v-collapse-toggle>
        <h3>{{$t('form.lot.price-criteria')}}</h3>
      </div>
      <div class="admin__a-tab-content admin__a-tab-content--show" v-collapse-content>
        <price-criteria :lot="lot"></price-criteria>
      </div>
    </v-collapse-wrapper>

    <v-collapse-wrapper :active="true">
      <div class="a-tab__title-block admin__a-tab admin__a-tab--modification-controls"
           v-collapse-toggle>
        <h3>{{$t('form.lot.specification')}}</h3>
      </div>
      <div class="admin__a-tab-content admin__a-tab-content--show" v-collapse-content>
        <specification :lot="lot"></specification>
      </div>
    </v-collapse-wrapper>
  </v-collapse-group>
</template>

<script>
  import ExpertCriteria from './specification/ExpertCriteria'
  import PriceCriteria from './specification/PriceCriteria'
  import Specification from './specification/Specification'
  import Parts from './specification/Parts'

  export default {
    props: {
      lot: Object
    },

    components: {
      ExpertCriteria, PriceCriteria, Specification, Parts
    }
  }
</script>

<style scoped>

</style>
